
import { Vue, Component, Emit } from 'vue-property-decorator';

@Component
export default class UploadFile extends Vue {

  upload(e) {
    const file = e.target.files[0];

    let reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      const text = reader.result;
      let json = JSON.parse(text as string);
      this.$store.commit('uploadMap', json);
      this.$emit('create-map-fn');
    };

    reader.onerror = () => {
      alert('读取文件失败')
    };
  }

}
